import React, {ReactElement, useEffect, useState} from 'react';
import style from './style.module.scss';
import {IBookingLinkItem} from './types';
import { createStyles, FormControl, Grid, InputAdornment, TextField, Theme } from '@material-ui/core';
import Fab from "@material-ui/core/Fab";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {makeStyles} from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import {renderIf} from "external-services/react-utils-service/index";
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import NotesIcon from '@material-ui/icons/Notes';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import classNames from 'classnames';
const NS = 'BookingLinkItem';


export default function BookingLinkItem({link, index, updateLinkName, updateLinkURL, deleteLink, editMode = true}: IBookingLinkItem) {

  const [newLinkName, setLinkName] = useState<string>(link.linkName);
  const [newLinkURL, setLinkURL] = useState<string>(link.linkURL);
  const [newEditMode, setEditMode] = useState<boolean>(editMode);

  useEffect(() => {
    setLinkName(link.linkName);
    setLinkURL(link.linkURL);

    if (!link.linkName && !link.linkURL) {
      setEditMode(true);
    }

  }, [link])

  function editLink() {
    setEditMode(true);
  }


  const DeleteButton: React.FunctionComponent = () => (
    <DeleteOutlineOutlinedIcon
      className={style.deleteIconV2}
      fontSize={"small"}
      onClick={() => {
        deleteLink(index)
      }}
    />
  );

  return (
    <div>
      <form noValidate autoComplete="off" className={classNames({
        [style.root]: true,
        [style.isEditMode]: newEditMode
      })} data-testid={`${newEditMode ? 'edit' : 'normal'}-mode`}>
        {renderIf(newEditMode, () => (
          <>
            <TextField
              className={style.nameInput}
              id="input-with-icon-textfield"
              placeholder="Name"
              defaultValue={newLinkName}
              InputProps={{
                classes: {
                  input: style.inputProps,
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <NotesIcon className={style.notesIcon} />
                  </InputAdornment>
                ),
              }}
              onChange={(event) => {
                setLinkName(event.target.value);
                return updateLinkName(event.target.value);
              }}
            />
            <TextField
              className={classNames({
                [style.urlInput]: true,
                [style.leftMargin]: true,
              })}
              id="input-with-icon-textfield"
              placeholder="URL"
              defaultValue={newLinkURL}
              InputProps={{
                classes: {
                  input: style.inputProps,
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <LinkOutlinedIcon className={style.linkIcon} />
                  </InputAdornment>
                ),
              }}
              onChange={(event) => {
                setLinkURL(event.target.value);
                return updateLinkURL(event.target.value);
              }}
            />
            <DeleteButton />
          </>
        ), () => ( // else !newEditMode
          <>
            <div className={style.linkWrap} >
              <Link href={newLinkURL} target="_blank" rel="noopener">
                {newLinkName ? newLinkName : newLinkURL}
              </Link>
            </div>
            <EditIcon
              className={style.editIconV2}
              fontSize={"small"}
              onClick={() => {
                editLink()
              }}
            />
            <DeleteButton />
          </>
        ))}
      </form>
    </div>
  );
}

